import {useLocation} from '@github-ui/react-router'
import type {SidebarLink} from '@github-ui/saved-views'
import {useNavigate} from '@github-ui/use-navigate'
import {useCallback, useTransition} from 'react'

import {repoSidebarLinks} from '../constants/repo-sidebar-links'
import {getRepoIssuesQueryPath} from '../utils/urls'

interface UseIssuesSidebarStateOptions {
  owner: string
  repo: string
}

export function useIssuesSidebarState({owner, repo}: UseIssuesSidebarStateOptions) {
  const {search} = useLocation()
  const navigate = useNavigate()
  const [isPending, startTransition] = useTransition()

  const searchParams = new URLSearchParams(search)
  const currentQuery = searchParams.get('q')?.trim() ?? ''
  const selectedLink = repoSidebarLinks.find(link => link.query === currentQuery)?.id ?? ''

  const onSelectLink = useCallback(
    (linkItem: SidebarLink) => {
      startTransition(() => {
        navigate(getRepoIssuesQueryPath({owner, repo, query: linkItem.query}))
      })
    },
    [navigate, owner, repo, startTransition],
  )

  return {selectedLink, onSelectLink, isPending}
}
